// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getEmail = state => state.forgotPasswordReducer.email;
export const getInfo = state => state.forgotPasswordReducer.info;
